// Whether the browser can hand an image file to the native share sheet (Web Share API level 2).
// This decides if the Instagram share button shares the story image directly or falls back to
// the download panel, and is also sent to Posthog so funnels can target the same users.
export const canShareImage = () => {
  const testFile = new File([], 'test.png', { type: 'image/png' })

  return Boolean(navigator.canShare?.({ files: [testFile] }))
}
